module.exports = __webpack_public_path__ + "static/assets/b9ca27eb73fdd4e247d8ec4089cdcef4.gif";